










































































































































































































import Vue from 'vue';
import validate from '@/utils/validate';
import { Component, Prop } from 'vue-property-decorator';
import { TCourseType, TCourseForm } from '@/types/views/educational';
import { TRules } from '@/types/utils.d.ts';
import { addCourse } from '@/api/educational';
import { State } from 'vuex-class';
const namespace = 'user';
interface IaddClassForm {
  className: string; // 班级名称
  teacherId: string; // 主讲老师id
  teachingMaterialId: string; // 教材id
  classDate: string; // 频率
}
@Component({})
export default class Add extends Vue {
  @State('orgId', { namespace }) orgId!: string;

  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  teacher!: [];

  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  materialList!: [];

  private dialogVisible = false;
  private pickerOptions = {
    disabledDate(time: Date) {
      return time.getTime() < Date.now() - 3600 * 1000 * 24;
    }
  };
  private form: TCourseForm = {
    freqList: [
      {
        frequenceType: '每周一',
        date: new Date()
      }
    ],
    mainTeacherId: '',
    assitantTeacherId: '',
    startTime: '',
    price: 0,
    minutes: '',
    timeDes: '',
    courseClassify: '',
    teachingMaterialId: '',
    className: ''
  };

  private course: any = {
    teachingmaterialWithBLOBs: {
      name: '',
      worksnum: '',
      lessonname: '',
      lessonlayer: '',
      toobject: '',
      lessondesc: '',
      type: 0
    },
    coursetype: 'OFFLINE'
  };

  private rules: TRules = {
    phone: [
      {
        required: true,
        validator: validate.validatorPhone_rule,
        trigger: 'blur'
      }
    ],
    className: [
      { required: true, message: '班级名称不能为空', trigger: 'blur' }
    ],
    startTime: [
      { required: true, message: '开始日期不能为空', trigger: 'blur' }
    ],
    mainTeacherId: [
      { required: true, message: '主讲老师不能为空', trigger: 'blur' }
    ],
    assitantTeacherId: [
      { required: true, message: '辅导老师不能为空', trigger: 'blur' }
    ],
    teachingMaterialId: [
      { required: true, message: '教材不能为空', trigger: 'blur' }
    ],
    minutes: [
      {
        required: true,
        validator: validate.validatorNumber_rule,
        trigger: 'blur'
      }
    ],
    price: [
      {
        required: true,
        validator: validate.validatorNumber_rule,
        trigger: 'blur'
      }
    ]
  };

  //  教材选择
  private handleMateriaChange(id: any) {
    for (let material of this.materialList) {
      if ((material as any).teachingmaterialWithBLOBs.id === id) {
        this.course = material as any;
        console.log(this.course)
      }
    }
  }

  private onSubmit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.form.startTime = new Date(this.form.startTime).getTime() + '';
        const condition = {
          ...this.form,
          courseName: this.course.teachingmaterialWithBLOBs.lessonname,
          lessonQty: this.course.coursenum,
          courseDes: this.course.teachingmaterialWithBLOBs.lessondesc || '无',
          courseLayer: this.course.teachingmaterialWithBLOBs.lessonlayer,
          courseType: this.course.coursetype,
          courseThumbURL:
            this.course.teachingmaterialWithBLOBs.headthumburl || 'www',
          target: this.course.teachingmaterialWithBLOBs.toobject || '无',
          teachingMatId: this.course.teachingmaterialWithBLOBs.id,
          orgId: this.course.orgid,
          type: this.course.teachingmaterialWithBLOBs.type
        };
        console.log(condition)
        this.addCourse(condition);
        const ref: any = this.$refs['form'];
        ref.resetFields();
      } else {
        this.$message.warning('请填写完整');
        return false;
      }
    });
  }
  private async addCourse(options: any) {
    try {
      try {
        const res: any = await addCourse({
          orgCourseDTOStr: JSON.stringify(options)
        });
        if (res.data) {
          this.dialogVisible = false;
          this.$router.push(`/educational/course-detail/${res.data.id}`);
        }
      } catch (err) {
        this.$message.warning(err.message);
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private addLessonList() {
    this.form.freqList.push({
      frequenceType: '每周一',
      date: new Date()
    });
  }
  private deleteLessonList(index: number) {
    this.form.freqList.splice(index, 1);
  }
}
